import type { AntennaType } from '@/features/jobs/types/job-detail'

const antennaTypeLabels: Record<AntennaType, string> = {
  internal: 'Internal',
  external: 'External',
}

export const formatAntennaType = (antennaType: AntennaType) =>
  antennaTypeLabels[antennaType]
